import React from "react";
import styled from "styled-components";
import Navbar from "./Navbar";
import Header from "./Header";

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    top: 0;
    position: sticky;
    position: -webkit-sticky;
    z-index: 1000;
`;

function Sticky () {
        return (
            <Wrapper>
                <Header />
                <Navbar />
            </Wrapper>
        )
    }
export default Sticky